
/**
 * Single Gallery - Category switching
 */
document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.block-single-gallery');

    blocks.forEach(block => {
        const buttons = block.querySelectorAll('.buttons__inside button');
        const galleryItems = block.querySelectorAll('.gallery-item');

        if (buttons.length === 0 || galleryItems.length === 0) return;

        // Ustaw pierwszą kategorię jako aktywną domyślnie
        initializeFirstActive();

        // Event listenery na przyciski filtrów
        buttons.forEach(button => {
            button.addEventListener('click', function() {
                setActiveGallery(this);
            });
        });

        // Nawigacja Previous/Next - dla każdej galerii
        galleryItems.forEach(galleryItem => {
            const prevBtn = galleryItem.querySelector('.type-navigation .prev');
            const nextBtn = galleryItem.querySelector('.type-navigation .next');

            if (prevBtn) {
                prevBtn.addEventListener('click', function() {
                    const currentActive = block.querySelector('.buttons__inside button.active');
                    const currentIndex = Array.from(buttons).indexOf(currentActive);
                    const prevIndex = currentIndex === 0 ? buttons.length - 1 : currentIndex - 1;
                    setActiveGallery(buttons[prevIndex]);
                });
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', function() {
                    const currentActive = block.querySelector('.buttons__inside button.active');
                    const currentIndex = Array.from(buttons).indexOf(currentActive);
                    const nextIndex = currentIndex === buttons.length - 1 ? 0 : currentIndex + 1;
                    setActiveGallery(buttons[nextIndex]);
                });
            }
        });

        // Inicjalizuj pierwszy element bez style
        function initializeFirstActive() {
            const firstButton = buttons[0];
            const firstCategoryId = firstButton.getAttribute('data-category-id');

            buttons.forEach(btn => btn.classList.remove('active'));
            firstButton.classList.add('active');

            galleryItems.forEach(item => {
                const itemCategoryId = item.getAttribute('data-category-id');
                if (itemCategoryId === firstCategoryId) {
                    item.classList.add('active');
                    item.style.maxHeight = 'none';
                } else {
                    item.classList.remove('active');
                    item.style.maxHeight = '0px';
                }
            });
        }

        // Funkcja przełączająca galerię
        function setActiveGallery(button) {
            const categoryId = button.getAttribute('data-category-id');

            // Aktualizuj przyciski
            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            // Przełącz galerię z dynamiczną wysokością
            galleryItems.forEach(item => {
                const itemCategoryId = item.getAttribute('data-category-id');
                if (itemCategoryId === categoryId) {
                    item.classList.add('active');
                    // Wylicz wysokość dynamicznie
                    setTimeout(() => {
                        const contentHeight = item.scrollHeight;
                        item.style.maxHeight = contentHeight + 'px';
                    }, 0);
                } else {
                    item.classList.remove('active');
                    item.style.maxHeight = '0px';
                }
            });
        }
    });
});
